import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deepCopy, getPaneIndex } from "../../../../../redux/constants";
import { setEnteredPlannedValue } from "../../../../../redux/actions/PlannedValue";
import {
  setTemplateFilter,
  setTemplateWidgetFilter,
} from "../../../../../redux/actions/section/section";
import { setIsWidgetEdit } from "../../../../../redux/actions/Filter";
import { Button, Tooltip } from "antd";

const PlannedValueField = ({ widgetData, type }) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const editPanelInfo = useSelector((state) => state.dashboard?.editPanelInfo);
  const Section = useSelector((state) => state.Section.addSection);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const selectedSection = useSelector((state) => state.Section.filterObject);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const selectLogicalBrandValue = useSelector(
    (state) => state?.Logicalgroup.selectLogicalBrandValue
  );
  const templateDateFilterObj = useSelector(
    (state) => state?.Section?.templateFilterObj
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const enteredPlannedValue = useSelector(
    (state) => state?.PlannedValue?.enteredPlannedValue
  );
  let index = getPaneIndex(panes, activeKey);

  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    resetPlannedValue();
  }, [type]);

  const resetPlannedValue = () => {
    if (type === "dashboard_widget") {
      let panes_data = panes?.[index]?.sections
        ? panes?.[index]?.sections?.[editPanelInfo?.section_index]?.widgets?.[
            editPanelInfo?.widget_index
          ]
        : panes?.[index]?.section?.[0]?.widgets?.[editPanelInfo?.widget_index];

      let updateEnteredPlannedValue = { ...enteredPlannedValue };
      updateEnteredPlannedValue[type].data = {
        value: panes_data?.chart?.chart_settings?.planned_val,
      };
      dispatch(setEnteredPlannedValue(updateEnteredPlannedValue));
    }
    if (type === "template_widget") {
      let section_data =
        editPanelInfo?.section_index >= 0
          ? Section?.[editPanelInfo?.section_index]?.data?.[
              editPanelInfo?.widget_index
            ]
          : Section?.[0]?.data?.[editPanelInfo?.widget_index];

      let updateEnteredPlannedValue = { ...enteredPlannedValue };
      updateEnteredPlannedValue[type].data = {
        value: section_data?.chart?.chart_settings?.planned_val,
      };
      dispatch(setEnteredPlannedValue(updateEnteredPlannedValue));
    }
  };

  const onDonePlannedValue = () => {
    dispatch(setIsWidgetEdit(false));

    let updatedSection = [...Section];

    if (editPanelInfo?.section_index >= 0) {
      updatedSection[editPanelInfo.section_index].data[
        editPanelInfo.widget_index
      ].chart.chart_settings.planned_val =
        enteredPlannedValue?.[type]?.data?.value;
      updatedSection[editPanelInfo.section_index].data[
        editPanelInfo.widget_index
      ].data = null;
    } else {
      updatedSection[0].data[
        editPanelInfo.widget_index
      ].chart.chart_settings.planned_val =
        enteredPlannedValue?.[type]?.data?.value;
      updatedSection[0].data[editPanelInfo.widget_index].data = null;
    }
    dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
  };

  // const onDonePlannedValue = () => {
  //   let widget_metadata =
  //     editPanelInfo?.section_index >= 0
  //       ? Section?.[editPanelInfo?.section_index]?.data?.[
  //           editPanelInfo?.widget_index
  //         ]
  //       : Section?.[0]?.data?.[editPanelInfo?.widget_index];

  //   let global = templateDetails?.templateFilters
  //     ? templateDetails?.templateFilters
  //     : [];

  //   let global_brands = templateDetails?.templateBrands
  //     ? templateDetails?.templateBrands
  //     : null;

  //   let global_duration = templateDetails?.templateDuration
  //     ? templateDetails?.templateDuration
  //     : null;

  //   let needToBeUpdateSectionAllWidgetsWithId = null;
  //   let templateObj1 = {
  //     section: Section,
  //     templateDetails: templateDetails,
  //     section_index: editPanelInfo?.section_index,
  //     authParams: authParams,
  //     brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,

  //     selectBrands: selectLogicalBrandValue[type]?.data,
  //   };
  //   let value = false;
  //   let templateObj = {
  //     section: Section,
  //     templateDetails: templateDetails,
  //     section_index: selectedSection?.section_index,
  //     widget_index: selectedSection?.widget_index,
  //     authParams: authParams,
  //     global_brands: selectedSection?.is_locked
  //       ? templateObj1?.selectBrands
  //         ? templateObj1?.selectBrands
  //         : selectedSection?.section_index
  //         ? Section[selectedSection?.section_index]?.data[
  //             selectedSection?.widget_index
  //           ]?.brandFilters
  //         : Section[0]?.data[selectedSection?.widget_index]?.brandFilters
  //       : global_brands,
  //     brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
  //     filters: value
  //       ? value
  //       : selectedSection?.section_index
  //       ? Section[selectedSection?.section_index]?.data[
  //           selectedSection?.widget_index
  //         ]?.onlyFilters
  //       : Section[0]?.data[selectedSection?.widget_index]?.onlyFilters,
  //     duration: selectedSection?.is_locked
  //       ? templateDateFilterObj?.templateObj?.durationObj
  //         ? templateDateFilterObj?.templateObj?.durationObj
  //         : Section[selectedSection?.section_index]?.dateFilters
  //         ? Section[selectedSection?.section_index]?.dateFilters
  //         : global_duration
  //       : global_duration,
  //     is_locked: widget_metadata?.profile_filters_flag
  //       ? true
  //       : selectedSection?.is_locked,
  //     brandFilters: templateObj1?.selectBrands
  //       ? templateObj1?.selectBrands
  //       : selectedSection?.section_index
  //       ? Section[selectedSection?.section_index]?.data[
  //           selectedSection?.widget_index
  //         ]?.brandFilters
  //       : Section[0]?.data[selectedSection?.widget_index]?.brandFilters,
  //     dateFilters: selectedSection?.section_index
  //       ? Section[selectedSection?.section_index]?.data[
  //           selectedSection?.widget_index
  //         ]?.dateFilters
  //       : Section[0]?.data[selectedSection?.widget_index]?.dateFilters,
  //     clear: false,
  //     span_check:
  //       templateDateFilterObj?.templateObj?.durationObj ||
  //       templateObj1?.selectBrands ||
  //       value?.length > 0
  //         ? true
  //         : false,
  //     brand_ids: selectLogicalBrandValue[type]?.data?.columns?.[0]?.name && {
  //       brand_id: selectLogicalBrandValue?.[type]?.data?.columns?.[0]?.name,
  //       brand_name:
  //         selectLogicalBrandValue?.[type]?.data?.columns?.[0]?.brand_name,
  //     },
  //     brand_groups: selectLogicalBrandValue[type]?.data,
  //     planned_value: enteredPlannedValue?.[type]?.data?.value,
  //   };

  //   dispatch(
  //     setTemplateWidgetFilter(
  //       templateObj,
  //       false,
  //       null,
  //       needToBeUpdateSectionAllWidgetsWithId
  //     )
  //   );

  //   let obj = {
  //     type: "template_widget",
  //     filters: global,
  //     section: Section,
  //     brands: templateDetails?.brands
  //       ? templateDetails?.brands
  //       : brandlogicalgroup?.length > 0
  //       ? brandlogicalgroup
  //       : brands,
  //     authParams: authParams,
  //     duration: templateDetails?.templateDuration
  //       ? templateDetails?.templateDuration
  //       : null,
  //     currentFilter: value ? value : [],
  //     graphConditionConfig: graphConditionConfig,
  //   };
  //   dispatch(setIsWidgetEdit(false));

  //   dispatch(setTemplateFilter(obj, templateObj));
  // };

  const updatePlannedValue = (value) => {
    if (value % 1 === 0 && value?.length <= 10) {
      let updateEnteredPlannedValue = { ...enteredPlannedValue };
      updateEnteredPlannedValue[type].data = {
        value: value,
      };
      dispatch(setEnteredPlannedValue(updateEnteredPlannedValue));

      setShowButton(true);
    }
  };

  return (
    <div className="d-flex">
      <div
        style={{
          width: showButton && type === "template_widget" ? "70%" : "100%",
          marginRight: showButton && type === "template_widget" ? "0.5rem" : "",
        }}
      >
        <input
          className="w-100 border-radius-4 border border-color"
          type="number"
          value={enteredPlannedValue?.[type]?.data?.value}
          placeholder="Planned Value"
          onChange={(e) => updatePlannedValue(e?.target?.value)}
        />
      </div>
      {showButton && type === "template_widget" && (
        <div style={{ width: "30%" }}>
          <Tooltip
            placement="topLeft"
            title={
              enteredPlannedValue?.[type]?.data?.value?.length === 0
                ? "Enter a planned value"
                : ""
            }
          >
            <Button
              block
              disabled={
                enteredPlannedValue?.[type]?.data?.value?.length === 0
                  ? true
                  : false
              }
              style={{
                color: "#fff",
                height: "4rem",
              }}
              className="ant-btn-primary_blue"
              type="primary"
              onClick={onDonePlannedValue}
            >
              Apply
            </Button>
          </Tooltip>
        </div>
      )}
    </div>
  );
};

export default PlannedValueField;
